import { render, staticRenderFns } from "./FaceidLogs.vue?vue&type=template&id=75e81568&scoped=true&"
import script from "./FaceidLogs.vue?vue&type=script&lang=js&"
export * from "./FaceidLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e81568",
  null
  
)

export default component.exports